<template>
  <div class="container">
    <v-row class="mt-0">
      <v-col cols="3">
        <v-card class="mt-0">
          <v-card-title class="blue accent-1 gray--text">Bins en Patio</v-card-title>
          <v-card-text>
            <chartist
              type="Pie"
              :data="chartPatioData"
              :options="chartPatioOptions" >
            </chartist>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="mt-0">
          <v-card-title class="blue accent-1 gray--text">Bins de 1000 por estado</v-card-title>
          <v-card-text>
            <chartist
              type="Pie"
              :data="chart1000Data"
              :options="chart1000Options" >
            </chartist>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="mt-0">
          <v-card-title class="blue accent-1 gray--text">Bins de 800 por estado</v-card-title>
          <v-card-text>
            <chartist
              type="Pie"
              :data="chart800Data"
              :options="chart800Options" >
            </chartist>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="mt-0">
          <v-card-title class="blue accent-1 gray--text">Antiguedad bins</v-card-title>
          <v-card-text>
            <v-data-table 
              :headers="frequencyListHeaders"
              :items="frequencyListBody"
              class="elevation-3 mt-5"
              no-data-text="No hay datos"
              :hide-default-footer="true"
              disable-pagination
              dense
            >
              <template slot="body.append">
                <tr class="primary--text">
                  <th class="title text-center">Total</th>
                  <th class="title text-center">
                      {{ sumaColumna('frequencyListBody', 'cantidad') }}
                  </th>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mt-0">
      <v-card-title class="blue accent-1 gray--text">Stock de Bins en Patio</v-card-title>
      <v-card-text>
        <v-data-table 
          :headers="stockPLPListHeaders"
          :items="stockPLPListBody"
          class="elevation-3 mt-5"
          no-data-text="No hay datos"
          :hide-default-footer="true"
          disable-pagination
          dense
        >
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card class="mt-5">
      <v-card-title class="blue accent-1 gray--text">Stock de Bins por Planta</v-card-title>
      <v-card-text>
        <v-data-table 
          :headers="stockFacilityListHeaders"
          :items="stockFacilityListBody"
          class="elevation-3 mt-5"
          no-data-text="No hay datos"
          :hide-default-footer="true"
          disable-pagination
          dense
        >
          <template slot="body.append">
            <tr class="primary--text">
              <th class="title text-center">Totales</th>
              <th class="title text-center">
                  {{ sumaColumna('stockFacilityListBody', 'val1') }}
              </th>
              <th class="title text-center">
                  {{ sumaColumna('stockFacilityListBody', 'val2') }}
              </th>
              <th class="title text-center">
                  {{ sumaColumna('stockFacilityListBody', 'total') }}
              </th>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card class="mt-5">
      <v-card-title class="blue accent-1 gray--text">Ultimas recepciones</v-card-title>
      <v-card-text>
        <v-data-table 
          :headers="lastReceptionsListHeaders"
          :items="lastReceptionsListBody"
          class="elevation-3 mt-5"
          no-data-text="No hay datos"
          dense
        ></v-data-table>
      </v-card-text>
    </v-card>

    <v-card class="mt-5">
      <v-card-title class="blue accent-1 gray--text">Ultimos despachos</v-card-title>
      <v-card-text>
        <v-data-table 
          :headers="lastShippingsListHeaders"
          :items="lastShippingsListBody"
          class="elevation-3 mt-5"
          no-data-text="No hay datos"
          dense
        ></v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'
  export default {
    props: {
      source: String,
    },
    data: () => ({
      chart1000Data: {
        ratio: "ct-major-second",
        labels: [],
        series: [],
      },
      chart1000Options: {
        chartPadding: 30,
        width: '100%',
        height: '100%',
      },
      chart800Data: {
        ratio: "ct-major-second",
        labels: [],
        series: [],
      },
      chart800Options: {
        chartPadding: 30,
        width: '100%',
        height: '100%',
      },
      chartPatioData: {
        ratio: "ct-major-second",
        labels: [],
        series: [],
      },
      chartPatioOptions: {
        chartPadding: 30,
        width: '100%',
        height: '100%',
      },
      isLoading: false,
      stockPLPListHeaders: [],
      stockPLPListBody: [],
      stockFacilityListHeaders: [
        {
          text: 'Planta',
          align: 'center',
          sortable: true,
          value: 'val0',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Azul 1000',
          align: 'center',
          sortable: true,
          value: 'val1',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Azul 800',
          align: 'center',
          sortable: true,
          value: 'val2',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Total',
          align: 'center',
          sortable: true,
          value: 'total',
          class: "salmon black--text elevation-3"
        },
      ],
      stockFacilityListBody: [],
      lastReceptionsListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'reception_date',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Turno',
          align: 'center',
          sortable: true,
          value: 'shift.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Patente',
          align: 'center',
          sortable: true,
          value: 'patent',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Bins',
          align: 'center',
          sortable: true,
          value: 'bins',
          class: "salmon black--text elevation-3"
        }
      ],
      lastReceptionsListBody:[],
      lastShippingsListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'shipping_date',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Turno',
          align: 'center',
          sortable: true,
          value: 'shift.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Planta Destino',
          align: 'center',
          sortable: true,
          value: 'facility.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Patente',
          align: 'center',
          sortable: true,
          value: 'patent',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Guia Despacho',
          align: 'center',
          sortable: true,
          value: 'waybill',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Certificado',
          align: 'center',
          sortable: true,
          value: 'certificate',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Bins',
          align: 'center',
          sortable: true,
          value: 'bins',
          class: "salmon black--text elevation-3"
        }
      ],
      lastShippingsListBody:[],
      frequencyListHeaders: [
        {
          text: 'Periodo',
          align: 'center',
          sortable: true,
          value: 'periodo',
          class: "salmon black--text elevation-3"
        },
        {
          text: '# Bins',
          align: 'center',
          sortable: true,
          value: 'cantidad',
          class: "salmon black--text elevation-3"
        },
      ],
      frequencyListBody:[],
    }),
    mounted() {
      this.mostrarLoading('Generando dashboard...');
      this.loadPLPStockReport();
      this.loadLastReceptionsReport();
      this.loadLastShippingsReport();
      this.loadFacilityStockReport();
      this.loadPatioGraph();
      this.loadBins1000PorEstado();
      this.loadBins800PorEstado();
      this.loadBinsFrequencyTable();
    },
    updated(){
      this.ocultarLoading();
    },
    methods:{
      sumaColumna(table, key) {
        let total = 0;
        this[table].forEach(row => {
            total += parseInt(row[key]);
        });
        return total;
      },
      async loadPLPStockReport(){
        let url = `${this.base_url}bins/report/facility/2`;
        await this.axios.get(url, this.headers).then((response) => {
          this.stockPLPListHeaders = response.data.data.headers;
          this.stockPLPListBody = response.data.data.body;
        }).catch((error) => {
            console.log(error);
        });
      },
      async loadFacilityStockReport(){
        //let url = `${this.base_url}bins/report/facility/-1`;
        let url = `${this.base_url}reports/facility/stock`;
        await this.axios.get(url, this.headers).then((response)=>{
          //this.stockFacilityListHeaders = response.data.data.headers;
          this.stockFacilityListBody = response.data.data.body;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadLastReceptionsReport(){
        let url = `${this.base_url}receptions/report/last/30`;
        await this.axios.get(url, this.headers).then((response) => {
          this.lastReceptionsListBody = response.data.data.report_data;
        }).catch((error) => {
            console.log(error);
        });
      },
      async loadLastShippingsReport(){
        let url = `${this.base_url}shippings/report/last/30`;
        await this.axios.get(url, this.headers).then((response) => {
          this.lastShippingsListBody = response.data.data.report_data;
        }).catch((error) => {
            console.log(error);
        });
      },
      async loadPatioGraph(){
        let url = `${this.base_url}graph/stock/patio`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.chartPatioData.labels = response.data.data.labels;
          this.chartPatioData.series = response.data.data.series;
          let series = response.data.data.series;
          let sum = function(a, b) {
            return parseFloat(a) + parseFloat(b) 
          };
          this.chartPatioOptions.labelInterpolationFnc = function(value, x) {
            let porc = Math.round(parseFloat(series[x]) / series.reduce(sum) * 100);
            return value + ' ' + porc + `% (${series[x]})`;
          }
        }).catch((error)=>{
          console.log(error);
        });
      },
      async loadBins1000PorEstado(){
        let url = `${this.base_url}graph/bystate/1`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.chart1000Data.labels = response.data.data.labels;
          this.chart1000Data.series = response.data.data.series;
          let series = response.data.data.series;
          let sum = function(a, b) {
            return parseFloat(a) + parseFloat(b) 
          };
          this.chart1000Options.labelInterpolationFnc = function(value, x) {
            let porc = Math.round(parseFloat(series[x]) / series.reduce(sum) * 100);
            return value + ' ' + porc + `% (${series[x]})`;
          }
        }).catch((error)=>{
          console.log(error);
        });
      },
      async loadBins800PorEstado(){
        let url = `${this.base_url}graph/bystate/2`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.chart800Data.labels = response.data.data.labels;
          this.chart800Data.series = response.data.data.series;
          let series = response.data.data.series;
          let sum = function(a, b) {
            return parseFloat(a) + parseFloat(b) 
          };
          this.chart800Options.labelInterpolationFnc = function(value, x) {
            let porc = Math.round(parseFloat(series[x]) / series.reduce(sum) * 100);
            return value + ' ' + porc + `% (${series[x]})`;
          }
        }).catch((error)=>{
          console.log(error);
        });
      },
      async loadBinsFrequencyTable(){
        let url = `${this.base_url}graph/binsage`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.frequencyListBody = response.data.data;
        }).catch((error)=>{
          console.log(error);
        });
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'headers'])
    },
    components:{}
  }
</script>
